import { ApiGetRequest } from '../api-get-request';

export class CustomerPaymentMethodsAgreementsRequest extends ApiGetRequest
{
    public constructor(webapiBasepath: string)
    {
        super(
            'billwerk/paymentmethods/agreements',
            null, //params
            null,
            webapiBasepath
        );
    }
}
